<template>
  <question-template name="goodsType" :info="info" />
</template>

<script>
export default {
  name: "GoodsTypes",
  data() {
    return {
      info: {
        title: "ต่างกันอย่างไร",
        path: "/info/goods_tax",
      },
    };
  },
};
</script>

<style scoped></style>
